import React from "react";
import './loading.css'
function Loader() {
  return (
    <div id="overlay">
      <div id="text" className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default Loader;